// Section for import npm components -----------------------------------------------------------------------------------
import React from 'react';

// Material UI ( mui ) components
import Link from '@mui/material/Link';
// Section for import custom types -------------------------------------------------------------------------------------
import ErrorImage from '@components/common/ErrorImage';
import { ErrorImageConvertUtility } from '@utils/ErrorImageConvertUtility';
import MansionImagePropsData from '@/types/components/MansionPopular/MansionImagePropsData';

// Section for render component ----------------------------------------------------------------------------------------
export default function MansionImage({ src, alt, href = '#' }: MansionImagePropsData): JSX.Element {
  return href ? (
    <Link href={href}>
      <picture>
        <source srcSet={src} />
        <ErrorImage
          alt={alt}
          className="mx-4 mt-4 mb-3 w-[248px] max-md:w-[233px] h-[154px] max-md:h-[144px] rounded  object-cover aspect-[4/3]"
          width="248"
          height="154"
          onError={(event: React.SyntheticEvent<HTMLImageElement>) => {
            ErrorImageConvertUtility.convertErrorImage(event.currentTarget);
          }}
        />
      </picture>
    </Link>
  ) : (
    <picture>
      <source srcSet={src} />
      <ErrorImage
        alt={alt}
        className="mx-4 my-2 w-full w-[248px] max-md:w-[233px] h-[154px] max-md:h-[144px] rounded  object-cover aspect-[4/3]"
        width="248"
        height="154"
        onError={(event: React.SyntheticEvent<HTMLImageElement>) => {
          ErrorImageConvertUtility.convertErrorImage(event.currentTarget);
        }}
      />
    </picture>
  );
}
